import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useMemo } from 'react'

import { METHOD_TYPE } from '@/components/core-tokens-list/MethodSelectionDialog'
import useTrans from '@/hooks/useTrans'

import { CURRENT_TYPE } from '../helpers'
import View from './view'

type ContainerProps = {
  currentType: string
  isOpen: boolean
  onClose: () => void
  onClick: (methodType: string) => void
}

const Container = ({ currentType, isOpen, onClick, onClose }: ContainerProps) => {
  const trans = useTrans()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))

  const isDepositing = useMemo(() => currentType === CURRENT_TYPE.deposit, [currentType])

  const methodOptions = useMemo(() => {
    if (isDepositing) {
      return [
        {
          title: trans.core_tokens_list.bank.deposit,
          description: trans.core_tokens_list.bank.description,
          type: METHOD_TYPE.bank,
          dataTestID: 'method-selection-bank',
          icon: '/assets-from-bank-icon.png',
        },
        {
          title: trans.core_tokens_list.network.deposit,
          description: trans.core_tokens_list.network.description,
          type: METHOD_TYPE.network,
          dataTestID: 'method-selection-network',
          icon: '/assets-from-others-icon.png',
        },
        {
          title: trans.core_tokens_list.swap_with_others,
          description: '',
          type: METHOD_TYPE.swapOthers,
          dataTestID: 'method-selection-swap-others',
          icon: '/top-coins-swap-with-others.png',
        },
      ]
    }

    return [
      {
        title: trans.core_tokens_list.bank.withdraw,
        description: trans.core_tokens_list.bank.description,
        type: METHOD_TYPE.bank,
        dataTestID: 'method-selection-bank',
        icon: '/assets-to-bank-icon.png',
      },
      {
        title: trans.core_tokens_list.network.withdraw,
        description: trans.core_tokens_list.network.description,
        type: METHOD_TYPE.network,
        dataTestID: 'method-selection-network',
        icon: '/assets-to-others-icon.png',
      },
    ]
  }, [isDepositing, trans])

  const computedProps = {
    isOpen,
    isDesktop,
    isDepositing,
    onClose,
    methodOptions,
    onClick,
  }

  return <View {...computedProps} />
}

export default Container
